import { render, staticRenderFns } from "./TicketCategory.vue?vue&type=template&id=5671e491&"
import script from "./TicketCategory.vue?vue&type=script&lang=js&"
export * from "./TicketCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports